"use client";
import { FunctionComponent, ReactNode, useEffect, useState } from "react";
import Router from "next/router";
import Spinner from "../Spinner/Spinner";
import { cn } from "../../../utils/cn";
export interface NextRouteLoaderProps {
  className?: string;
  children: ReactNode;
}

/**
 *
 */
export const NextRouteLoader: FunctionComponent<NextRouteLoaderProps> = ({
  className,
  children,
}) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    function start() {
      setLoading(true);
    }
    function complete() {
      setLoading(false);
    }
    function error() {
      setLoading(false);
    }

    Router.events.on("routeChangeStart", start);
    Router.events.on("routeChangeComplete", complete);
    Router.events.on("routeChangeError", error);
    return () => {
      Router.events.off("routeChangeStart", start);
      Router.events.off("routeChangeComplete", complete);
      Router.events.off("routeChangeError", error);
    };
  }, []);
  const css = cn(className, "absolute inset-0 grid place-content-center");

  return (
    <>
      {loading && (
        <div className={css}>
          <Spinner size={"4rem"} className="text-primary-500" />
        </div>
      )}
      {!loading && children}
    </>
  );
};
